import React from "react";
import { useNavigate } from "react-router-dom";
import { Share2, Star, Home, MapPin, Globe, Sparkles, ArrowUp, ArrowDown } from "lucide-react";
import { scoreColor } from "../lib/growth";

const ICON = { social: Share2, reputation: Star, property_marketing: Home, local_authority: MapPin, website_digital: Globe, brand_activity: Sparkles };

export default function PillarCard({ pillar, movement }) {
  const navigate = useNavigate();
  const Icon = ICON[pillar.key] || Share2;
  const c = scoreColor(pillar.score);
  return (
    <button onClick={() => navigate(`/app/growth-score?pillar=${pillar.key}`)} data-testid={`pillar-${pillar.key}`}
      className="card card-hover p-4 text-left w-full">
      <div className="flex items-center justify-between">
        <span className="grid place-items-center w-8 h-8 rounded-lg" style={{ background: "var(--grad-green-soft)" }}>
          <Icon size={16} strokeWidth={1.75} style={{ color: "#5F8213" }} />
        </span>
        {movement != null && movement !== 0 && (
          <span className="inline-flex items-center gap-0.5 text-xs font-bold" style={{ color: movement > 0 ? "#5F8213" : "#D0526B" }}>
            {movement > 0 ? <ArrowUp size={12} strokeWidth={2.5} /> : <ArrowDown size={12} strokeWidth={2.5} />}{Math.abs(movement)}
          </span>
        )}
      </div>
      <div className="mt-3 flex items-baseline gap-1">
        <span className="text-2xl font-extrabold tracking-tighter text-ink">{pillar.score ?? "—"}</span>
        <span className="text-xs text-ink-3 font-semibold">/ 100</span>
      </div>
      <div className="text-sm font-semibold text-ink mt-0.5">{pillar.label}</div>
      <div className="mt-2 h-1.5 rounded-full overflow-hidden" style={{ background: "#EDEEE9" }}>
        <div className="h-full rounded-full transition-all duration-700" style={{ width: `${pillar.score || 0}%`, background: c }} />
      </div>
      <div className="text-[11px] text-ink-3 mt-2">{pillar.weight ? Math.round(pillar.weight * 100) : ""}% of score · {pillar.signal_count} signals</div>
    </button>
  );
}
